import { Typography } from '@recruit-robin/robin-theme/web-components';

import type { IndeedJob } from 'shared/legacy/hooks/useBrowserExtension/indeed/indeed.types';

import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { sanitizeEmailHtml } from 'utils/sanitizeEmailHtml';
import { useStyles } from './IndeedTooltip.styles';

export const IndeedTooltip = ({ indeedJob }: { indeedJob: IndeedJob }) => {
  const { dictionary } = useContext(LocalizationContext);
  const classes = useStyles();

  return (
    <span>
      <Typography variant={(v) => v.body.short} inline>
        {indeedJob.name}
      </Typography>
      <Typography
        variant={(v) => v.body.short}
        color={(c) =>
          indeedJob.type === 'custom' || indeedJob.status === 'PAUSED'
            ? c.tertiary.lime[40]
            : indeedJob.status === 'ACTIVE'
              ? c.secondary.emerald[40]
              : c.tertiary.red[40]
        }
        inline>
        {' '}
        ({indeedJob.type === 'custom' ? 'CUSTOM' : indeedJob.status})
      </Typography>
      <br />
      {indeedJob.type !== 'custom' && (
        <Typography variant={(v) => v.body.short} inline>
          {dictionary.location}: {indeedJob.location}
        </Typography>
      )}
      <br />
      <Typography variant={(v) => v.body.short} customCss={classes.description}>
        <span dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(indeedJob.description) }}></span>
      </Typography>
    </span>
  );
};
